const APP_SETTINGS = '/app-settings';

export function appSettings() {
  return APP_SETTINGS;
}

export function appEnums() {
  return `${APP_SETTINGS}/enums`;
}

export function appCategories() {
  return `${APP_SETTINGS}/categories`;
}
